import React from 'react';
import { SubmenuContainerProps } from './types';
import { st, classes } from './SubmenuContainer.component.st.css';

export const SubmenuContainer: React.FC<SubmenuContainerProps> = ({
  children,
  isSubmenuContainerStretched,
}) => {
  return (
    <div
      className={st(classes.root, { isStretched: isSubmenuContainerStretched })}
    >
      {children}
    </div>
  );
};
